import { TrendingUp, TrendingDown, Minus } from 'lucide-react';
import { Card } from '../components/ui/card';
import { cn } from '../lib/utils';

export const KPICard = ({ kpi, onClick }) => {
    const formatValue = (value, unit) => {
        if (value === null || value === undefined) return '--';
        
        if (unit === '$') {
            return new Intl.NumberFormat('en-US', {
                style: 'currency',
                currency: 'USD',
                minimumFractionDigits: 0,
                maximumFractionDigits: 0
            }).format(value);
        }
        
        if (unit === '%') {
            return `${value.toFixed(1)}%`;
        }
        
        if (value >= 1000000) {
            return `${(value / 1000000).toFixed(1)}M`;
        }
        if (value >= 1000) {
            return `${(value / 1000).toFixed(1)}K`;
        }
        
        return value.toFixed(1);
    };

    const getTrendIcon = () => {
        if (!kpi.trend) return <Minus className="h-4 w-4 text-muted-foreground" />;
        if (kpi.trend === 'up') return <TrendingUp className="h-4 w-4 text-secondary" />;
        return <TrendingDown className="h-4 w-4 text-destructive" />;
    };

    const getTrendColor = () => {
        if (!kpi.trend) return 'text-muted-foreground';
        
        // For metrics where up is bad (churn rate)
        if (kpi.name === 'Churn Rate') {
            return kpi.trend === 'up' ? 'text-destructive' : 'text-secondary';
        }
        
        return kpi.trend === 'up' ? 'text-secondary' : 'text-destructive';
    };

    return (
        <Card 
            className={cn(
                "p-6 bg-card border-border cursor-pointer transition-all duration-300",
                "hover:border-primary/50 hover:-translate-y-1"
            )}
            onClick={onClick}
            data-testid={`kpi-card-${kpi.name.toLowerCase().replace(/\s+/g, '-')}`}
        >
            <div className="space-y-3">
                <div className="flex items-center justify-between">
                    <span className="label-text">{kpi.name}</span>
                    {getTrendIcon()}
                </div>
                
                <div className="kpi-value text-primary">
                    {formatValue(kpi.latest_value, kpi.unit)}
                </div>
                
                {kpi.change_percent !== null && kpi.change_percent !== undefined && (
                    <div className={cn("flex items-center gap-2 text-sm", getTrendColor())}>
                        <span className="font-mono font-medium">
                            {kpi.change_percent > 0 ? '+' : ''}
                            {kpi.change_percent.toFixed(1)}%
                        </span>
                        <span className="text-muted-foreground">vs previous</span>
                    </div>
                )}
            </div>
        </Card>
    );
};

export default KPICard;
